import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

type AmenityProps = {
  $card?: boolean;
};

export const CardContainer = styled.div`
  border-radius: 16px;
  background-color: ${({ theme }) => theme.hotelDetails.background};
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.hotelDetails.boxShadow};
`;

export const AmenitiesContainer = styled.div`
  padding: 16px 24px;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 8px;
`;

export const Amenity = styled.h5<AmenityProps>`
  border: ${({ $card }) => ($card ? `1px solid ${ColorPalette.HEX.DimGray}` : 'none')};
  border-radius: 8px;
  padding: 8px;
  height: 32px;

  display: flex;
  align-items: center;
  overflow: hidden;

  & > img {
    width: ${({ $card }) => ($card ? 16 : 21)}px;
    height: ${({ $card }) => ($card ? 16 : 21)}px;
    margin-right: ${({ $card }) => ($card ? 4 : 12)}px;
    filter: invert(0.3);
  }

  & > span {
    color: ${ColorPalette.HEX.DimGray};
    font-size: ${({ $card }) => ($card ? 10 : 14)}px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const Line = styled.hr`
  height: 1px;
  border: 0 none;
  background-color: ${ColorPalette.HEX.BrightGray};
  margin: 16px 0;
`;
